// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const security = "Security__security__vIp1s";
export const summary = "Security__summary__ZRexQ";
export const summaryTitle = "Security__summaryTitle__qe0SZ font-faces__serifLight__iGPdI font-faces__serif__XseuP";
export const summaryText = "Security__summaryText__uGS1a font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const blockTitle = "Security__blockTitle__9VL47 font-faces__sansMedium__DqLMY font-faces__sans__uCf65";
export const blockText = "Security__blockText__rYkvv font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const partnerLogos = "Security__partnerLogos__rvb9i";
export const partnerLogo = "Security__partnerLogo__Iy-Ig";